<template>
  <div>
    <div class="cmp-handle" style="z-index: 999">
      <el-dropdown>
        <span class="el-dropdown-link">
          <i class="el-input__icon el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="settingVisible=true"
                            style="text-align: center">设置
          </el-dropdown-item>
          <el-dropdown-item @click.native="handleCmp('delete',componentIndex)"
                            style="text-align: center">删除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <p style="font-size: 15px">信号名</p>
    <el-select size="mini" style="width: 100px;" v-model="value" placeholder="请选择">
      <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
    <el-dialog
        :append-to-body="true"
        :visible.sync="settingVisible"
        title="设置"
        width="50%">
      <el-tabs v-model="tabIndex">
        <el-tab-pane label="数据设置">
          <el-table
              :data="options"
              border
              style="width: 100%">
            <el-table-column
                type="index"
                label="#"
                width="50">
            </el-table-column>
            <el-table-column
                label="Label"
                width="280">
              <template slot-scope="scope">
                <el-input v-model="scope.row.label"></el-input>
              </template>
            </el-table-column>
            <el-table-column
                label="Value">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.value" style="width: 100%" controls-position="right"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="50">
              <template slot-scope="scope">
                <el-button
                    @click.native.prevent="deleteRow(scope.$index, options)"
                    type="text"
                    size="small">
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="样式设置">
          <el-row>
            <el-col :span="8">
              <span style="font-size: 16px;display: block">字体大小</span>
              <el-input-number size="mini" v-model="exampleFontSize" :min="12" :max="30" controls-position="right" style="width: 80%"></el-input-number>
            </el-col>
            <el-col :span="8">
              <span style="font-size: 16px;display: block">颜色</span>
              <el-color-picker size="mini" v-model="exampleFontColor" show-alpha></el-color-picker>
            </el-col>
            <el-col :span="8">
              <span style="font-size: 16px;display: block">预览</span>
              <span :style="`${'font-size: '+exampleFontSize +'px;color: '+exampleFontColor}`">信号名</span>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <span class="dialog-footer" slot="footer">
        <el-button @click="settingVisible = false">取 消</el-button>
        <el-button v-show="tabIndex==='0'" @click="addOption" type="primary">新 增</el-button>
        <el-button @click="settingVisible = false" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';

export default {
  name: 'PullDown',
  props: {
    componentIndex: {
      type: Number,
    },
  },
  data() {
    return {
      fontColor: '#303133',
      exampleFontColor: '#303133',
      fontSize: 15,
      exampleFontSize: 15,
      options: [{
        value: '0',
        label: 'R',
      }, {
        value: '1',
        label: 'N',
      }, {
        value: '11',
        label: 'C',
      }, {
        value: '9',
        label: 'B',
      }, {
        value: '7',
        label: 'P',
      }],
      value: '',
      tabIndex: '0',
      settingVisible: false,
    };
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    handleCmp(command, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({ index });
          break;
        default:
          break;
      }
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    addOption() {
      const newOption = {
        value: '13',
        label: 'X',
      };
      this.options.push(newOption);
    },
  },
};
</script>

<style scoped>
  .el-input__icon {
    line-height: 25px;
    opacity:0;
  }
  .cmp-handle {
    position: absolute;
    top: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/PullDown.vue